import React from "react";

import { useLanguage } from "../LanguageProvider";

const icons = [
  <svg width="44" height="44" fill="none" viewBox="0 0 24 24"><path d="M4 17V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10" stroke="#B91C1C" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/><rect x="7" y="10" width="10" height="7" rx="2" fill="#B91C1C" opacity=".12"/></svg>,
  <svg width="44" height="44" fill="none" viewBox="0 0 24 24"><path d="M12 2v20M2 12h20" stroke="#B91C1C" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="12" cy="12" r="10" stroke="#B91C1C" strokeWidth="2.2"/><circle cx="12" cy="12" r="6" fill="#B91C1C" opacity=".12"/></svg>,
  <svg width="44" height="44" fill="none" viewBox="0 0 24 24"><path d="M17 7a5 5 0 1 1-10 0" stroke="#B91C1C" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/><rect x="5" y="7" width="14" height="10" rx="2" fill="#B91C1C" opacity=".12"/></svg>,
  <svg width="44" height="44" fill="none" viewBox="0 0 24 24"><path d="M6 19V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14" stroke="#B91C1C" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/><rect x="9" y="8" width="6" height="8" rx="1" fill="#B91C1C" opacity=".12"/></svg>,
  <svg width="44" height="44" fill="none" viewBox="0 0 24 24"><path d="M12 20v-6M12 14V4" stroke="#B91C1C" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/><rect x="8" y="14" width="8" height="6" rx="2" fill="#B91C1C" opacity=".12"/></svg>,
  <svg width="44" height="44" fill="none" viewBox="0 0 24 24"><path d="M4 17V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10" stroke="#B91C1C" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/><rect x="7" y="10" width="10" height="7" rx="2" fill="#B91C1C" opacity=".12"/></svg>
];

export default function WhyUsSection() {
  const { dict } = useLanguage();
  
  const items = [
    { title: dict.elonyok?.fastTitle, desc: dict.elonyok?.fastDesc, emoji: '⚡' },
    { title: dict.elonyok?.designTitle, desc: dict.elonyok?.designDesc, emoji: '🎨' },
    { title: dict.elonyok?.ecoTitle, desc: dict.elonyok?.ecoDesc, emoji: '🌿' },
    { title: dict.elonyok?.sustainTitle, desc: dict.elonyok?.sustainDesc, emoji: '♻️' },
    { title: dict.elonyok?.warrantyTitle, desc: dict.elonyok?.warrantyDesc, emoji: '🛡️' },
    { title: dict.elonyok?.handoverTitle, desc: dict.elonyok?.handoverDesc, emoji: '🔑' }
  ];

  return (
    <section className="py-20 md:py-32 bg-gradient-to-b from-[#0a0a0a] via-[#1a1a1a] to-[#0a0a0a] relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-96 h-96 bg-secondary/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-green-500/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-1/2 left-1/2 w-[600px] h-[600px] bg-secondary/5 rounded-full blur-[150px]" />
      </div>
      
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-secondary/20 to-red-600/20 backdrop-blur-xl border border-secondary/30 rounded-full px-6 py-3 mb-8 shadow-2xl shadow-secondary/20">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-secondary"></span>
            </span>
            <span className="text-secondary font-bold text-sm tracking-wider">✨ ELŐNYEINK</span>
          </div>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-6 tracking-tight leading-tight">
            Miért válassz <span className="bg-gradient-to-r from-secondary via-red-500 to-secondary bg-clip-text text-transparent">minket</span>?
          </h2>
          <p className="text-gray-300 text-lg md:text-2xl max-w-3xl mx-auto font-light">
            Prémium minőség, gyors kivitelezés, teljes körű garancia
          </p>
        </div>
        
        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map((item, i) => (
            <div
              key={i}
              className="group relative bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-xl border border-white/10 rounded-3xl p-8 hover:border-secondary/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-secondary/20 cursor-pointer"
              style={{animationDelay: `${i * 100}ms`}}
            >
              {/* Icon with glow */}
              <div className="relative mb-4">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-[#e31937]/20 to-[#e31937]/5 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <span className="text-3xl md:text-4xl">{item.emoji}</span>
                </div>
                <div className="absolute inset-0 w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-[#e31937]/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              
              {/* Content */}
              <h3 className="text-lg md:text-xl font-bold text-white mb-2 group-hover:text-[#e31937] transition-colors duration-300">
                {item.title}
              </h3>
              <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                {item.desc}
              </p>
              
              {/* Hover Arrow */}
              <div className="mt-4 flex items-center gap-2 text-[#e31937] opacity-0 group-hover:opacity-100 transform translate-x-[-10px] group-hover:translate-x-0 transition-all duration-300">
                <span className="text-sm font-medium">Tudj meg többet</span>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
